import { css } from 'lit';

export const nsAnimationStyles = css`
  .animation-modes {
    position: absolute;
    top: 20px;
    right: 20px;

    background: var(--ns-theme-container);
    color: var(--ns-theme-black);

    border-radius: var(--wa-border-radius-l);

    padding: var(--wa-space-xs);

    z-index: 2;
  }

  .animation-modes.loading-animation-modes {
    top: 200px;
  }

  /* Logo animation */
  .main-logo-animation {
    font-family: 'Cy';
  }
  .main-logo-animation.login .text {
    line-height: 1;
    font-size: var(--wa-font-size-5xl);
  }
  .main-logo-animation.login img {
    width: 120px;
  }
  .main-logo-animation img {
    width: 50px;
  }
  .main-logo-animation .logo,
  .main-logo-animation .text {
    overflow: hidden;
  }
  .main-logo-animation .upward-logo {
    text-align: right;
  }
  .main-logo-animation .downward-logo {
    text-align: left;
  }

  .main-logo-animation .upward-logo img,
  .main-logo-animation.start .upward-logo img {
    position: relative;
  }
  .main-logo-animation .upward-logo img,
  .main-logo-animation.start .upward-logo img {
    left: 5px;
  }
  .main-logo-animation.login .upward-logo img,
  .main-logo-animation.login.start .upward-logo img {
    left: 25px;
  }

  .main-logo-animation .downward-logo img,
  .main-logo-animation.start .downward-logo img {
    position: relative;
  }
  .main-logo-animation .downward-logo img,
  .main-logo-animation.start .downward-logo img {
    left: -5px;
  }
  .main-logo-animation.login .downward-logo img,
  .main-logo-animation.login.start .downward-logo img {
    left: -25px;
  }

  .main-logo-animation .upward-logo,
  .main-logo-animation .upward-text {
    transform: translate(0, 100%);
  }
  .main-logo-animation .downward-logo,
  .main-logo-animation .downward-text {
    transform: translate(0, -100%);
  }

  .main-logo-animation.start .upward-logo,
  .main-logo-animation.start .downward-logo,
  .main-logo-animation.start .upward-text,
  .main-logo-animation.start .downward-text {
    transform: translate(0, 0);
  }

  /* Loading Animation */
  .loading-animation.layout.inline {
    position: absolute;
    height: 100vh;

    overflow: hidden;
    z-index: 3;

    display: none;
  }

  .loading-animation.collapse,
  .loading-animation.start,
  .loading-animation.finish {
    display: flex;

    align-items: center;
    justify-content: center;
  }

  .loading-animation .animation-background {
    position: absolute;
  }

  .loading-animation .animation-background img {
    width: 200px;
  }

  .loading-animation .animation-background .upper-side,
  .loading-animation .animation-background .bottom-side {
    height: 250%;
  }

  .loading-animation .animation-background .upper-side {
    position: absolute;

    background: var(--ns-theme-black);
    clip-path: polygon(50% 100%, 100% 0, 20% 0);
  }

  .loading-animation .animation-background .bottom-side {
    position: absolute;
    bottom: 0;

    background: var(--ns-theme-black);
    clip-path: polygon(50% 0, 80% 100%, 0 100%);
  }

  .loading-animation .animation-background .upper-side {
    transform: translate(0, -100%);
  }
  .loading-animation .animation-background .bottom-side {
    transform: translate(0, 100%);
  }
  .loading-animation.collapsed .animation-background .upper-side {
    transform: translate(20%, 0);
  }
  .loading-animation.collapsed .animation-background .bottom-side {
    transform: translate(-20%, 0);
  }

  .loading-animation .loading-animation-wrapper .logo-upward img {
    width: 100px;
    opacity: 0;

    transform: translate(20px, 0);
  }
  .loading-animation .loading-animation-wrapper .logo-downward img {
    width: 100px;
    opacity: 0;

    transform: translate(-20px, 0);
  }

  .loading-animation.started .loading-animation-wrapper .logo-upward img {
    opacity: 1;
  }

  .loading-animation.started .loading-animation-wrapper .logo-downward img {
    opacity: 1;
  }

  .loading-animation.finish .animation-background .upper-side {
    transform: translate(0, -100vh);
  }
  .loading-animation.finish .animation-background .bottom-side {
    transform: translate(0, 100vh);
  }

  .loading-animation.hide-logo .loading-animation-wrapper .logo-upward img {
    opacity: 0;
  }
  .loading-animation.hide-logo .loading-animation-wrapper .logo-downward img {
    opacity: 0;
  }
`;
